// src/components/IPhoneMockup.js
import React from 'react';
import { motion } from 'framer-motion'; // Import motion for animations
import './IPhoneMockup.css'; // This CSS will define the iPhone's shape

function IPhoneMockup({ children }) {
  // Variants for the iPhone frame itself, for subtle animation
  const phoneVariants = {
    active: { 
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.4), inset 0 0 15px rgba(255, 255, 255, 0.2)",
      scale: 1.02, // Slightly larger on active
      transition: { duration: 0.5, ease: "easeOut" }
    },
    inactive: { 
      boxShadow: "0 15px 30px rgba(0, 0, 0, 0.3), inset 0 0 10px rgba(255, 255, 255, 0.1)",
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  return (
    <motion.div 
      className="iphone-frame-wrapper"
      variants={phoneVariants} // Apply phone specific variants
      initial="inactive"
      animate="active" // Will be controlled by parent component via props later
      exit="inactive"
    >
      {/* The notch element, styled purely with CSS */}
      <div className="iphone-notch">
        <div className="iphone-speaker"></div> {/* Small line for speaker */}
        <div className="iphone-sensor"></div> {/* Small dot for sensor */}
      </div>
      
      {/* This div will hold your GIF and represent the screen area */}
      <div className="iphone-screen-content">
        {children} {/* Your GIF/video screen recording will be rendered here */}
      </div>
    </motion.div>
  );
}

export default IPhoneMockup;